// departmentData.js

export const DepartmentData = [
  {
    id: 1,
    departmentCode: "DEP-001",
    departmentName: "Customer Support",
    headOfDepartment: "Sunita Sharma",
    contactNumber: "+977-9801122334",
    email: "support@dms.com",
    totalEmployees: 30,
    branchAssigned: "Kathmandu Central",
    activeDisputes: 12,
    resolvedDisputes: 80,
    createdDate: "2024-02-18",
    status: "Active",
  },
  {
    id: 2,
    departmentCode: "DEP-002",
    departmentName: "Legal Affairs",
    headOfDepartment: "Rajesh Koirala",
    contactNumber: "+977-9811223344",
    email: "legal@dms.com",
    totalEmployees: 15,
    branchAssigned: "Lalitpur Office",
    activeDisputes: 5,
    resolvedDisputes: 42,
    createdDate: "2024-03-10",
    status: "Active",
  },
  {
    id: 3,
    departmentCode: "DEP-003",
    departmentName: "Fraud Investigation",
    headOfDepartment: "Anuja Thapa",
    contactNumber: "+977-9822334455",
    email: "fraud@dms.com",
    totalEmployees: 10,
    branchAssigned: "Pokhara Lakeside",
    activeDisputes: 7,
    resolvedDisputes: 33,
    createdDate: "2024-04-25",
    status: "Active",
  },
  {
    id: 4,
    departmentCode: "DEP-004",
    departmentName: "Finance & Audit",
    headOfDepartment: "Kiran Adhikari",
    contactNumber: "+977-9845123456",
    email: "finance@dms.com",
    totalEmployees: 8,
    branchAssigned: "Biratnagar East",
    activeDisputes: 2,
    resolvedDisputes: 25,
    createdDate: "2024-06-15",
    status: "Inactive",
  },
  {
    id: 5,
    departmentCode: "DEP-005",
    departmentName: "Operations",
    headOfDepartment: "Madhav KC",
    contactNumber: "+977-9809988776",
    email: "operations@dms.com",
    totalEmployees: 20,
    branchAssigned: "Chitwan Bharatpur",
    activeDisputes: 4,
    resolvedDisputes: 60,
    createdDate: "2024-07-20",
    status: "Active",
  },
];

